module.exports = __webpack_public_path__ + "static/media/image-map-default.6a2682f9.jpeg";